import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import FontObserver from 'fontfaceobserver';
import { canUseDOM } from 'fbjs/lib/ExecutionEnvironment';
export default {
  get name() {
    return 'ExpoFontLoader';
  },

  loadAsync: function loadAsync(fontFamilyName, resource) {
    var canInjectStyle, style;
    return _regeneratorRuntime.async(function loadAsync$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (canUseDOM) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            canInjectStyle = document.head && typeof document.head.appendChild === 'function';

            if (canInjectStyle) {
              _context.next = 5;
              break;
            }

            throw new Error('E_FONT_CREATION_FAILED : document element cannot support injecting fonts');

          case 5:
            style = _createWebStyle(fontFamilyName, resource);
            document.head.appendChild(style);

            if (!navigator.userAgent.includes('Edge')) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return");

          case 9:
            return _context.abrupt("return", new FontObserver(fontFamilyName).load());

          case 10:
          case "end":
            return _context.stop();
        }
      }
    });
  }
};
var ID = 'expo-generated-fonts';

function getStyleElement() {
  var element = document.getElementById(ID);

  if (element && element instanceof HTMLStyleElement) {
    return element;
  }

  var styleElement = document.createElement('style');
  styleElement.id = ID;
  styleElement.type = 'text/css';
  return styleElement;
}

function _createWebStyle(fontFamily, resource) {
  var fontStyle = "@font-face {\n    font-family: " + fontFamily + ";\n    src: url(" + resource.uri + ");\n  }";
  var styleElement = getStyleElement();

  if (styleElement.styleSheet) {
    var styleElementIE = styleElement;
    styleElementIE.styleSheet.cssText = styleElementIE.styleSheet.cssText ? styleElementIE.styleSheet.cssText + fontStyle : fontStyle;
  } else {
    var textNode = document.createTextNode(fontStyle);
    styleElement.appendChild(textNode);
  }

  return styleElement;
}